<template>
	<div>
		<aside class="search-btn">
			<vButtonGroup class="tablelist-tabs clearfix" compact>
				<vButton
					size="large"
					v-for="(item,index) in btnsearch"
					:key="index"
					:theme="formData.itemstatus===item.value?'primary':'default'"
					@click="handleBtn('status',item.value)"
				>{{item.label}}</vButton>
			</vButtonGroup>
			<!--  账单汇总 -->
            <div v-if="formData.itemstatus==1">
                <comTotal></comTotal>
            </div>
			<!-- 账单明细 -->
            <div v-if="formData.itemstatus==0">
                <RadioGroup v-model="formData.chosetype" class="margin-top-10 margin-bottom-10">
                    <Radio label="0" >仓库作业费</Radio>
                    <Radio label="1" >仓储费</Radio>
                    <Radio label="2" >增值服务费</Radio>
                    <Radio label="4" >配送费</Radio>
                    <Radio label="3" >调账</Radio>
                </RadioGroup>
                <compCostall v-if="formData.chosetype == 0"></compCostall>
                <compStorage v-if="formData.chosetype == 1"></compStorage>
                <compZengzhi v-if="formData.chosetype == 2"></compZengzhi>
                <compReconciliation v-if="formData.chosetype == 3"></compReconciliation>
                <compShiping v-if="formData.chosetype == 4"></compShiping>
            </div>
		</aside>
	</div>
</template>
<script>
import compCostall from "./detail/account.js";
import compStorage from "./detail/storage.js"
import compZengzhi from "./detail/zengzhi.js"
import compReconciliation from "./detail/reconciliation.js"
import compShiping from "./detail/shipdetail.js"

import comTotal from "./total/index"

export default {
	components: {
        comTotal,

		compCostall,
        compStorage,
        compZengzhi,
        compReconciliation,
        compShiping,
	},
	data() {
		return {
			btnsearch: [{
				value: 1,
				label: '账单汇总'
			}, {
				value: 0,
				label: '账单明细'
			},],
			formData: {
				itemstatus: 1,
                chosetype:'0',
			}
		}
	},
	computed: {
		columns() {
			return [

			]
		}
	},
	methods: {
		handleBtn(type, value) {
			// console.log(2222)
			this.formData.itemstatus = value
		}
	},
}
</script>
